import React from "react";
import Swal from "sweetalert2"; // Import SweetAlert2
import { FiX } from "react-icons/fi"; // Import cross icon from react-icons
import "../Products/Cartpopus.css";

const Cartpopups = ({ product, onClose, updateCart }) => {
  if (!product) return null;

  // Handle quantity change (decrement or increment)
  const handleQuantityChange = (amount) => {
    const newQuantity = product.quantity + amount;
    if (newQuantity > 0) {
      updateCart(product.id, newQuantity); // Update quantity if > 0
    }
  };

  // Use the image from the public folder (assuming images are in /public/images/)
  const imageSrc = `${product.image}`;

  // Show SweetAlert when "Add to Cart" is clicked
  const handleAddToCart = () => {
    Swal.fire({
      title: "Added to Cart!",
      text: `${product.name} has been successfully added to your cart.`,
      icon: "success",
      confirmButtonText: "OK",
    }).then(() => {
      onClose(); // Close the popup after SweetAlert confirmation
    });
  };

  return (
    <div className="cart-popup-p" style={{ display: "block", zIndex: 1000 }}>
      <div className="popup-content-p">
        {/* Close Button */}
        <button className="close-popup-p" onClick={onClose}>
          <FiX />
        </button>

        {/* Product Image */}
        <div className="popup-image-p">
          <img src={imageSrc} alt={product.name} />
        </div>

        {/* Product Details */}
        <div className="popup-details-p">
          <h3>{product.name}</h3>
          <p>{product.description || "No description available."}</p>
          <div className="popup-price-p">
            <span>Total Price: </span>
            <strong>₹{(product.price * product.quantity).toFixed(2)}</strong>
          </div>

          {/* Quantity Controls */}
          <div className="popup-quantity-p">
            <button className="c-b" onClick={() => handleQuantityChange(-1)}>-</button>
            <span>{product.quantity}</span>
            <button className="c-b" onClick={() => handleQuantityChange(1)}>+</button>
          </div>

          {/* Add to Cart Button */}
          <button className="add-to-cart-p" onClick={handleAddToCart}>
            Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
};

export default Cartpopups;
